import { useSelector } from "react-redux";
import { getAvailableCreditsTotal } from "app/pages/Account/MyCoupons/couponSelector";
import SearchEngineCreditBanner from "app/pages/PrePackage/components/SearchEngineCreditBanner/SearchEngineCreditBanner";

const SearchEngineCreditBannerContainer = () => {
	const totalCredit = useSelector(getAvailableCreditsTotal);
	return <SearchEngineCreditBanner totalCredit={totalCredit} />;
};

export default SearchEngineCreditBannerContainer;
